<!--
 * @Author: ocean
 * @Description: 数据统计 充电数据统计 电站统计列表
-->
<template>
  <scroll-layout class="powerstationStatistics-list">
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageButtons"
          :key="index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
    </template>
    <div class="wrap-box">
      <div class="tags">
        报表统计口径说明
        <span @click="tagClick()">?</span>
      </div>
      <div>
        <ykc-table
          ref="YkcTable"
          operateFixedType="right"
          :data="tableData"
          :title="tableTitle"
          :columns="tableColumns"
          :operateButtons="tableOperateButtons">
          <ykc-pagination
            align="right"
            slot="pagination"
            ref="YkcPagination"
            :total="pageInfo.total"
            :page-size.sync="pageInfo.size"
            :current-page.sync="pageInfo.current"
            @current-change="handlePaginationCurrentChange"
            @size-change="handlePaginationSizeChange"></ykc-pagination>
        </ykc-table>
        <ykc-operation-dialog
          size="large"
          title="统计口径说明"
          confirm-btn-txt="同意"
          :show-footer="false"
          :show.sync="operationStatus">
          <div slot="content">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              :autosize="{ minRows: 2 }"
              v-model="textarea2"></el-input>
          </div>
        </ykc-operation-dialog>
      </div>
    </div>
  </scroll-layout>
</template>
<script>
  import { getLastTime } from '@/utils';
  import { dataStatisticsServe } from '@/service/apis';

  export default {
    name: 'powerstationStatisticsListDetail',
    components: {},
    data() {
      return {
        operationStatus: false,
        pageButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        searchParam: {
          endTime: '',
          startTime: '',
          stationId: '',
        },
        tableTitle: '明细列表', // 列表表格
        tableData: [],
        tableOperateButtons: [], // 列表操作
        tableColumns: [
          {
            label: '日期',
            prop: 'billDay',
            fixed: true,
            width: '200px',
            id: 0,
          },
          {
            label: '电站名称',
            prop: 'stationName',
            width: '200px',
            scopedSlots: {
              default: ({ row }) => {
                return (
                  <div onClick={() => this.handleRowClick(row)}>
                    <span style="{ color: blue, cursor: pointer }">{row.stationName}</span>
                  </div>
                );
              },
            },
            id: 1,
          },
          {
            label: '场地名称',
            prop: 'siteName',
            minWidth: '150px',
            id: 13,
          },
          { label: '归属商户', prop: 'stationOperatorName', minWidth: '150px', id: 2 },
          { label: '城市', prop: 'cityName', minWidth: '150px', id: 3 },
          { label: '枪数', prop: 'gunCount', minWidth: '150px', id: 13 },
          { label: '电量(度)', prop: 'chargedPower', minWidth: '150px', id: 4 },
          { label: '充电时长(h)', prop: 'chargedTime', minWidth: '150px', id: 5 },
          { label: '充电次数', prop: 'chargedCount', minWidth: '150px', id: 6 },
          { label: '电费(元)', prop: 'chargedAmount', minWidth: '150px', id: 7 },
          { label: '服务费(元)', prop: 'serviceAmount', minWidth: '150px', id: 8 },
          { label: '订单总金额(元)', prop: 'totalAmount', minWidth: '160px', id: 9 },
          { label: '电费实付(元)', prop: 'chargedAmountDiscount', minWidth: '160px' },
          { label: '服务费实付(元)', prop: 'parkedAmountDiscount', minWidth: '160px' },
          {
            label: '用户实付合计(元)',
            prop: 'chargedAmountAfterDiscount',
            minWidth: '160px',
            id: 10,
          },
          { label: '引流抽成费用(元)', prop: 'commissionAmount', minWidth: '160px', id: 11 },
          { label: '商户实收合计(元)', prop: 'operatorActualIncome', minWidth: '160px', id: 12 },
        ],
        pageInfo: {
          current: 1,
          size: 10,
        },
        textarea2: `电量(度)：所有历史订单电量汇总
  充电时长(h)：所有历史订单充电时长汇总
  充电次数：订单总数量
  电费(元)：所有历史订单原价电费
  服务费(元)：所有历史订单原价服务费
  订单总金额(元)：所有历史订单原价总金额
  用户实付合计(元)：订单总金额- 平台卡券优惠- 平台活动优惠-商户卡券优惠-商户活动优惠-会员折扣优惠
  引流抽成费用(元)：所有历史订单引流抽成总金额
  商户实收合计(元)：订单总金额-商户卡券优惠-商户活动优惠-引流抽成费用`,
      };
    },
    created() {
      this.searchParam.startTime = this.$route.query.startDate;
      this.searchParam.endTime = this.$route.query.endDate;
      this.searchParam.stationId = this.$route.query.stationId;
      this.requestList();
    },
    computed: {},
    methods: {
      /**
       * 请求列表数据
       */
      requestList() {
        const pageInfos = (({ current, size }) => ({ current, size }))(this.pageInfo);
        const reqParams = {
          ...pageInfos,
          endTime: this.searchParam.endTime,
          startTime: this.searchParam.startTime,
          stationId: this.searchParam.stationId,
        };
        dataStatisticsServe
          .stationChargingDetailDayList(reqParams)
          .then(res => {
            this.tableData = res.records || [];
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 统计说明
       */
      tagClick() {
        this.operationStatus = true;
      },
      /**
       * 详情页面
       */
      handleDetail(row) {
        this.$router.push({
          path: '/dataStatistics/chargingStatistics/powerstationStatistics/ListDetail',
          query: { stationId: row.stationId },
        });
      },

      /**
       * 跳转电站
       */
      handleRowClick(row) {
        let url = '/plantAssets/powerStationManagement/directConnectionStation/Detail';
        if (row.stationType === '1') {
          url = '/plantAssets/powerStationManagement/directConnectionStation/Detail';
        } else if (row.stationType === '2') {
          url = '/plantAssets/powerStationManagement/interconnectionStation/Detail';
        }
        this.$router.push({
          path: url,
          query: { stationId: row.stationId },
        });
      },
      /**
       * 分页器页数
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      /**
       * 分页器条数
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.requestList();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .ykc-checkbox .icon-check {
    top: 7px;
  }

  .but-box {
    display: flex;
    justify-content: flex-end;
  }
  .powerstationStatistics-list {
    .wrap-box {
      position: relative;
      .tags {
        display: flex;
        align-items: center;
        font-size: 12px;
        position: absolute;
        top: 20px;
        left: 85px;
        > span {
          display: block;
          width: 16px;
          height: 16px;
          margin-left: 8px;
          font-size: 10px;
          line-height: 16px;
          color: #fff;
          text-align: center;
          cursor: pointer;
          border-radius: 50%;
          background: blue;
        }
      }

      .ykc-table {
        .el-table .el-table__row {
          .cell .userStatus {
            padding-left: 8px;
            position: relative;
          }

          .cell .userStatus::after {
            display: block;
            content: '';
            width: 5px;
            height: 5px;
            border-radius: 100%;
            background: #d0021b;
            position: absolute;
            top: 5.5px;
            left: 0;
          }

          .cell .status-blue::after {
            background: #4d8cfd;
          }

          .cell .status-green::after {
            background: #02c498;
          }

          .cell .status-black::after {
            background: #9b9b9b;
          }
        }

        .sealBtn {
          color: #4d8cfd;
          cursor: pointer;
        }
      }
    }
    .bottomBtn {
      position: absolute;
      right: 10px;
      bottom: 20px;
      width: 90px;
      height: 45px;
      border-radius: 10px;
      color: #409eff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
      background-color: #fff;
      padding-right: 5px;
      cursor: pointer;
      z-index: 1000;

      i {
        margin: 0 5px;
      }
      &:hover {
        background-color: #f2f6fc;
      }
    }
  }
</style>
